import { render, staticRenderFns } from "./PayDialog.vue?vue&type=template&id=4d2f6475&scoped=true"
import script from "./PayDialog.vue?vue&type=script&lang=js"
export * from "./PayDialog.vue?vue&type=script&lang=js"
import style0 from "./PayDialog.vue?vue&type=style&index=0&id=4d2f6475&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2f6475",
  null
  
)

export default component.exports